<script>
import CandelaComponent from '@/components/CandelaComponent'
import csv_parser from 'papaparse'

export default {
  extends: CandelaComponent,
  data() {
    return {
      page: 0,
      rows_per_page: 5
    }
  },
  computed: {
    headers() {
      return Object.keys(this.items[0]).map(k => {
        return {text: k.toUpperCase(), value: k}
      })
    },
    items() {
      switch(this.format) {
        case 'csv':
          return csv_parser.parse(this.data, {header: true}).data
        default:
          return this.data
      }
    }
  },
  name: 'candela-data-table',
  props: {
    data: {default: () => []},
    format: {type: String, default: () => 'csv'}
  }
}
</script>

<template>
<div class='candela-component ignore-drag'>
  <v-data-table :headers='headers' :items='items' :items-per-page='5'
    class='d-flex flex-column justify-space-between flex-grow-1'>
    <template v-slot:items="props">
      <td v-for='(h, i) in headers' :key='i'>{{props.item[h.value]}}</td>
    </template>
  </v-data-table>
</div>
</template>

<style lang='sass' scoped>
::v-deep table
  height: 100%
  white-space: nowrap

::v-deep .v-data-table__wrapper
  flex-grow: 1
</style>
